export default __webpack_public_path__ + "static/media/ProductsList_img4_Cn.03c77866.webp";